var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$store.state.loading)?_c('div',[_c('TheFilters'),_c('SearchResultsCoureurs'),_c('b-row',[_c('b-col',{attrs:{"md":"8"}},[_c('StatistiquesCourse')],1),_c('b-col',{attrs:{"md":"4"}},[_c('ThePagination')],1)],1),_c('TheTable')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }